<template>
  <v-container>
    <div>
      <v-btn color="primary" @click="back" class="noprint mr-3">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
    </div>
    <div class="mt-3">
      <iframe
        :src="url"
        frameborder="0"
        type="application/pdf"
        width="100%"
        height="800px"
      ></iframe>
    </div>
  </v-container>
</template>

<script>
import "jspdf-autotable";
import { jsPDF } from "jspdf";
import moment from "moment";
import angkaTerbilang from "@develoka/angka-terbilang-js";

export default {
  name: "print-preview-settlement",
  props: {
    id: Number,
  },
  data() {
    return {
      kasbon: {},
      url: "",
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    async getSettlement() {
      this.$store.commit("SET_LOADER", true);
      try {
        const response = await this.$store.dispatch("settlementKasbon/getById", this.id);
        this.kasbon = response.data;
        this.createPdf();
      } catch (e) {
        this.$store.dispatch("toast", {
          type: "error",
          message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
        });
      } finally {
        this.$store.commit("SET_LOADER", false);
      }
    },
    formatPrice(value) {
      if (value === null) {
        return "";
      }
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    createPdf() {
      const doc = new jsPDF();

      doc.setFont("Times", "bold");
      doc.setFontSize(14);
      doc.text("PENYELESAIAN KAS BON", 5, 10);
      doc.line(5, 11, 68, 11);

      doc.rect(78, 6, 4, 4);
      doc.setFont("Times", "normal");
      doc.setFontSize(10);
      doc.text("Uang sudah diterima", 85, 9);

      doc.text("Tanggal :", 137, 9);
      doc.line(157, 10, 205, 10);
      doc.text(moment(this.kasbon.kasbonDate).format("DD-MMM-YY"), 157, 9);
      doc.text("Assign# :", 137, 15);
      doc.text(`${this.kasbon.kasbonNumber != null ? this.kasbon.kasbonNumber : ""}`, 157, 15);

      doc.text("Perusahaan", 5, 25);
      doc.text(":", 39, 25);
      doc.line(42, 26, 205, 26);
      doc.text("PT. GRAHA SUMBER PRIMA ELEKTRONIK", 42, 25);

      doc.text("Nama", 5, 30);
      doc.text(":", 39, 30);
      doc.line(42, 31, 120, 31);
      doc.text(this.kasbon.name, 42, 30);
      doc.text("Divisi", 130, 30);
      doc.text(":", 140, 30);
      doc.line(155, 31, 205, 31);
      doc.text(this.kasbon.division, 155, 30);

      doc.text("Jumlah", 5, 35);
      doc.text(":", 39, 35);
      doc.line(42, 36, 205, 36);
      doc.text(`Rp.     ${this.formatPrice(this.kasbon.totalUseAmount)}`, 42, 35);

      doc.text("Terbilang", 5, 40);
      doc.text(":", 39, 40);
      doc.line(42, 41, 205, 41);
      doc.text(`${angkaTerbilang(this.kasbon.totalUseAmount)} rupiah`, 42, 40);

      doc.text("Pembayaran", 5, 60);
      doc.text("Tunai", 42, 60);
      if (this.kasbon.paymentMethod === "Cash") {
        doc.rect(68, 57, 4, 4);
        doc.text("X", 72, 60);
      } else {
        doc.rect(68, 57, 4, 4);
      }
      doc.text("Transfer", 94, 60);
      if (this.kasbon.paymentMethod === "Transfer" && this.kasbon.bankAccountNumber !== null) {
        doc.rect(124, 57, 4, 4);
        doc.text("X", 125, 60);
        doc.text("Nama Penerima", 10, 65);
        doc.text(":", 39, 65);
        doc.line(42, 66, 120, 66);
        doc.text(
          this.kasbon.external
            ? this.kasbon.externalAccountNumber.ownerName
            : this.kasbon.ownerBank
            ? this.kasbon.ownerBank
            : this.kasbon.name,
          42,
          65
        );
        doc.text("Tgl Transfer", 130, 65);
        doc.text(":", 150, 65);
        doc.line(155, 66, 205, 66);

        doc.text("Bank", 10, 70);
        doc.text(":", 39, 70);
        doc.line(42, 71, 205, 71);
        doc.text(this.kasbon.external ? this.kasbon.externalAccountNumber.bankName : "BCA", 42, 70);

        doc.text("No Rekening", 10, 75);
        doc.text(":", 39, 75);
        doc.line(42, 77, 205, 77);
        doc.text(
          this.kasbon.external
            ? this.kasbon.externalAccountNumber.accountNumber
            : this.kasbon.bankAccountNumber,
          42,
          75
        );
      } else {
        doc.rect(124, 57, 4, 4);
        doc.text("Nama Penerima", 10, 65);
        doc.text(":", 39, 65);
        doc.line(42, 66, 120, 66);
        doc.text("Tgl Transfer", 130, 65);
        doc.text(":", 150, 65);
        doc.line(155, 66, 205, 66);

        doc.text("Bank", 10, 70);
        doc.text(":", 39, 70);
        doc.line(42, 71, 205, 71);

        doc.text("No Rekening", 10, 75);
        doc.text(":", 39, 75);
        doc.line(42, 77, 205, 77);
      }

      doc.text("Jumlah Kas Bon", 5, 82);
      doc.text(":", 39, 82);
      doc.line(42, 83, 205, 83);
      doc.text(`Rp.     ${this.formatPrice(this.kasbon.totalAmount)}`, 42, 82);

      doc.text("Sisa Kas Bon", 5, 87);
      doc.text(":", 39, 87);
      doc.line(42, 88, 205, 88);
      doc.text(`Rp.     ${this.formatPrice(this.kasbon.totalRemainAmount)}`, 42, 87);

      doc.text("Keterangan", 5, 92);
      doc.text(":", 39, 92);
      doc.line(42, 93, 205, 93);

      doc.text("Untuk Keperluan", 5, 97);
      doc.text(":", 39, 97);
      let splitTitle = doc.splitTextToSize(this.kasbon.remark, 120);
      doc.text(splitTitle, 42, 97);

      // Calculate the height of the remark text to prevent overlap
      let remarkTextHeight = doc.getTextDimensions(splitTitle).h;
      let y = Math.max(120, 97 + remarkTextHeight + 5);
      for (let i = 0; i < this.kasbon.items.length; i++) {
        let text = `${this.kasbon.items[i].description} ${moment(
          this.kasbon.items[i].startDate
        ).format("DD")}-${moment(this.kasbon.items[i].endDate).format("DD")}/${moment(
          this.kasbon.items[i].startDate
        ).format("MMM")}`;
        let splitText = doc.splitTextToSize(text, 150);
        let textHeight = doc.getTextDimensions(splitText).h;
        if (i == 0) {
          doc.text(splitText, 42, y, { maxWidth: 150 });
          doc.text(this.formatPrice(this.kasbon.items[i].usedAmount), 205, y + textHeight, {
            align: "right",
          });
          doc.line(42, y + 1 + textHeight, 205, y + 1 + textHeight);
        } else {
          doc.text(splitText, 42, y, { maxWidth: 150 });
          doc.text(this.formatPrice(this.kasbon.items[i].usedAmount), 205, y + textHeight, {
            align: "right",
          });
          doc.line(42, y + textHeight + 1, 205, y + textHeight + 1);
        }
        y += 5 + textHeight + 1;
      }

      // Build signature stamp data
      const approvalSignatures = this.kasbon.approvalSignatures || [];
      const createdAtFormatted = this.kasbon.createdAt
        ? moment(this.kasbon.createdAt).format("DD-MMM-YY HH:mm")
        : "";

      const stampDiminta = { name: this.kasbon.name, date: createdAtFormatted };
      const stampDiketahui =
        approvalSignatures.length > 0
          ? {
              name: approvalSignatures[0].employeeName,
              date: approvalSignatures[0].completedAt
                ? moment(approvalSignatures[0].completedAt).format("DD-MMM-YY HH:mm")
                : "",
            }
          : null;
      const stampDisetujui =
        approvalSignatures.length > 1
          ? approvalSignatures.slice(1).map(sig => ({
              name: sig.employeeName,
              date: sig.completedAt ? moment(sig.completedAt).format("DD-MMM-YY HH:mm") : "",
            }))
          : [];

      const stampEnabled = this.kasbon.stampEnabled;

      const disetujuiCount = Math.max(stampDisetujui.length, 0);
      const stampHeight = 32;
      const minHeight = stampEnabled ? Math.max(40, stampHeight + disetujuiCount * 28) : 40;

      const drawStamp = (d, cx, cy, name, dateStr) => {
        const r = 11;
        d.setDrawColor(139, 0, 0);
        d.setLineWidth(0.7);
        d.circle(cx, cy, r);
        d.setLineWidth(0.3);
        d.circle(cx, cy, r - 1.8);
        d.setLineWidth(0.4);
        d.line(cx - 7, cy - 3.5, cx + 7, cy - 3.5);
        d.line(cx - 7, cy + 2.5, cx + 7, cy + 2.5);
        d.setTextColor(139, 0, 0);
        d.setFont("Times", "bold");
        d.setFontSize(7);
        d.text("APPROVED", cx, cy + 0.5, { align: "center" });
        d.setFont("Times", "normal");
        d.setFontSize(5.5);
        d.text(dateStr, cx, cy + 5.5, { align: "center" });
        d.setTextColor(0, 0, 0);
        d.setFont("Times", "bold");
        d.setFontSize(7);
        d.text(name, cx, cy + r + 4, { align: "center" });
        d.setDrawColor(0);
        d.setTextColor(0);
        d.setLineWidth(0.1);
        d.setFont("Times", "normal");
        d.setFontSize(10);
      };

      doc.autoTable({
        margin: { left: 5, right: 5 },
        startY: y + 10,
        theme: "plain",
        head: [["Diminta Oleh :", "Diketahui Oleh :", "Disetujui Oleh :", "Diterima Oleh :"]],
        body: [
          [
            { content: "", styles: { lineWidth: 0.1 } },
            { content: "", styles: { lineWidth: 0.1 } },
            { content: "", styles: { lineWidth: 0.1 } },
            {
              content: "Tgl. ___________________",
              styles: { valign: "top", halign: "left", lineWidth: 0.1, fontStyle: "normal" },
            },
          ],
        ],
        styles: {
          valign: "middle",
          tableWidth: "auto",
          lineWidth: 0.1,
          halign: "left",
          lineColor: "black",
          minCellHeight: minHeight,
        },
        headStyles: {
          valign: "middle",
          halign: "center",
          tableWidth: "auto",
          minCellHeight: 0,
        },
        columnStyles: {
          0: { cellWidth: 50 },
          1: { cellWidth: 50 },
          2: { cellWidth: 50 },
          3: { cellWidth: 50 },
        },
        didDrawCell: data => {
          if (data.section !== "body") return;
          if (!stampEnabled) return;
          const cx = data.cell.x + data.cell.width / 2;
          const baseY = data.cell.y + 16;
          if (data.column.index === 0) {
            drawStamp(doc, cx, baseY, stampDiminta.name, stampDiminta.date);
          }
          if (data.column.index === 1 && stampDiketahui) {
            drawStamp(doc, cx, baseY, stampDiketahui.name, stampDiketahui.date);
          }
          if (data.column.index === 2 && stampDisetujui.length > 0) {
            stampDisetujui.forEach((sig, i) => {
              drawStamp(doc, cx, baseY + i * 28, sig.name, sig.date);
            });
          }
        },
      });

      this.url = doc.output("datauristring");
    },
  },
  created() {
    this.getSettlement();
  },
};
</script>

<style></style>
